import { useContext } from "react"

import { SearchByContractProvider, SearchByContractContext } from "./provider"

interface IUseSearchByContractReturn {
    handleIdContratoSelecionado: (contract: number) => void
    idContratoSelecionado: number
}
const UseSearchByContract = (): IUseSearchByContractReturn => {
    const {
        idContratoSelecionado: idContratoSelecionado,
        setIdContratoSelecionado
    } = useContext(SearchByContractContext)

    const handleIdContratoSelecionado = (contract: number) => {
        setIdContratoSelecionado(contract)
    }

    return {
        handleIdContratoSelecionado,
        idContratoSelecionado
    }
}

export {
    UseSearchByContract,
    SearchByContractProvider
}